import React from "react";
import { S, openConsult } from "../site.js";

const discussPartnership = openConsult({ source: "tiktok" });
const { useEffect: useEffect_TT, useRef: useRef_TT, useState: useState_TT } = React;

const TT_CHANNEL = {
  name: "NIR Myanmar",
  handle: "rizu5570gv4",
  profileUrl: "https://www.tiktok.com/@rizu5570gv4",
};

const TT_VIDEOS = [
  { id: "7637499010915290388", author: TT_CHANNEL.handle },
  { id: "7636258422039514389", author: TT_CHANNEL.handle },
  { id: "7630000211745721621", author: TT_CHANNEL.handle },
  { id: "7621343948761550100", author: TT_CHANNEL.handle },
];

const TT_ROTATE_MS = 7000;

function TikTok() {
  const [active, setActive] = useState_TT(0);
  const [inView, setInView] = useState_TT(false);
  const [muted, setMuted] = useState_TT(true);
  const phoneRef = useRef_TT(null);
  const iframeRef = useRef_TT(null);

  useEffect_TT(() => {
    if (!inView) return;
    const timer = window.setInterval(() => {
      setActive((i) => (i + 1) % TT_VIDEOS.length);
    }, TT_ROTATE_MS);
    return () => window.clearInterval(timer);
  }, [inView]);

  useEffect_TT(() => {
    if (typeof IntersectionObserver === "undefined" || !phoneRef.current) return;
    const el = phoneRef.current;
    const observer = new IntersectionObserver(([entry]) => {
      setInView(entry.isIntersecting);
    }, { threshold: 0.5 });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const current = TT_VIDEOS[active];

  useEffect_TT(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const send = (type) => {
      iframe.contentWindow && iframe.contentWindow.postMessage(
        { type, "x-tiktok-player": true },
        "https://www.tiktok.com",
      );
    };
    if (inView) {
      const t = window.setTimeout(() => send("play"), 250);
      return () => window.clearTimeout(t);
    }
    send("pause");
  }, [inView, current.id]);

  useEffect_TT(() => { setMuted(true); }, [current.id]);

  useEffect_TT(() => {
    function onMessage(e) {
      if (e.origin !== "https://www.tiktok.com") return;
      const data = e.data;
      if (!data || data["x-tiktok-player"] !== true) return;
      if (data.type === "onMute" && typeof data.value === "boolean") {
        setMuted(data.value);
      }
    }
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  const toggleMute = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const next = !muted;
    iframe.contentWindow && iframe.contentWindow.postMessage(
      { type: next ? "mute" : "unMute", "x-tiktok-player": true },
      "https://www.tiktok.com",
    );
    setMuted(next);
  };

  return (
    <section className="section-pad tiktok-review-compact" id="tiktok">
      <div className="container">
        <div className="tiktok-review-compact-grid">
          <div className="tiktok-review-copy">
            <div className="eyebrow">TIKTOK MEDIA PARTNERSHIP</div>
            <h2>Connect with Myanmar audiences through short-form media.</h2>
            <p>
              Explore selected brand partnerships, sponsored content, and short-form PR through our Myanmar-focused TikTok channel.
            </p>
            <p className="tiktok-review-note">
              Campaign scope and deliverables are agreed separately.
            </p>
            <div className="tiktok-review-actions">
              <a href={TT_CHANNEL.profileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-arrow">
                <span>View our TikTok channel</span>
              </a>
              <a href={S.nextStep} onClick={discussPartnership} className="btn btn-secondary btn-arrow">
                <span>Discuss a media partnership</span>
              </a>
            </div>
          </div>

          <div className="tiktok-review-phone-wrap" ref={phoneRef}>
            <div className="tiktok-review-phone">
              <div className="tiktok-review-screen">
                <iframe
                  key={current.id}
                  ref={iframeRef}
                  title={`TikTok video by @${current.author}`}
                  src={`https://www.tiktok.com/player/v1/${current.id}?autoplay=1&muted=1&controls=0&progress_bar=0&play_button=0&volume_control=0&fullscreen_button=0&closed_caption=0&timestamp=0&description=0&music_info=0&native_context_menu=0&rel=0&loop=1`}
                  loading="lazy"
                  allow="autoplay; encrypted-media; picture-in-picture; web-share; fullscreen"
                  allowFullScreen
                  scrolling="no"
                />
                <button
                  type="button"
                  onClick={toggleMute}
                  aria-label={muted ? "Unmute video" : "Mute video"}
                  aria-pressed={!muted}
                  className="tiktok-review-sound"
                >
                  {muted ? "Sound off" : "Sound on"}
                </button>
                <span className="tiktok-review-notch" aria-hidden="true" />
              </div>
              <div className="tiktok-review-meta">
                <div className="tiktok-review-dots" aria-label={`Video ${active + 1} of ${TT_VIDEOS.length}`}>
                  {TT_VIDEOS.map((_, i) => <span key={i} data-active={i === active} />)}
                </div>
                <span>@{current.author}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { TikTok };
